module.exports = __webpack_public_path__ + "static/logo-bbbca4704f3eb92933baa076f3e214f6.svg";